import React from 'react'
import CommonCountryFlage from './CommonCountryFlage'

function CommonFlag(countryCode="IT",phoneNumber="") {
  return (
   <>
   
   <div className="" style={{
        marginRight:40,
        marginBottom:5
       }}>
       <CommonCountryFlage country={countryCode}/>

       </div>
        <div className="">{phoneNumber}</div></>
  )
}

export default CommonFlag